import styled from "@emotion/styled/macro";
import { Dialog as ReachDialog } from "@reach/dialog";
import * as mq from "styles/media-queries";
import * as colors from "styles/colors";

const Dialog = styled(ReachDialog)({
  position: "fixed",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  zIndex: 999,
  height: "max-content",
  backgroundColor: colors.white,
  maxWidth: "450px",
  borderRadius: "3px",
  padding: "10px",
  boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.2)",
  margin: "20vh auto",
  [mq.small]: {
    width: "100%",
    margin: "10vh auto",
  },
});

export default Dialog;
